import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { PublicWorkspaceBrandingService } from '../services/workspace-branding/public-workspace-branding.service';

export const publicRegistrationGuard: CanActivateFn = (route) => {
  const router = inject(Router);
  const workspaceBranding = inject(PublicWorkspaceBrandingService);
  const workspace = workspaceBranding.workspaceFromRoute(route);

  if (!workspace && !workspaceBranding.isBrandedPortalHost()) {
    return true;
  }

  return router.createUrlTree(['/login'], {
    queryParams: workspace ? { workspace } : undefined,
  });
};
